import React from "react"
import styled, { css } from "styled-components"
import { colors, fontWeight } from "buoy-theme"
import { RawHTML } from "buoy-core"
import Text from "../../common/components/Text"
import Link from "../../common/components/Link"
import { SITE_URL, STATIC_URL } from "../../common/constants"
import BuoyChatIcon, { ChatIconWrapper } from "./BuoyChatIcon"
import { responsive } from "../../common/styledHelpers"

const calculatePadding = props => {
  if (props.item && props.item.index === 0) {
    return responsive("padding-top", "40px", "16px")
  } else {
    return "padding-top: 10px"
  }
}

const Container = styled.div`
  display: ${props => (props.hide ? "none" : "inline-flex")};
  ${props => calculatePadding(props)};
  position: relative;
  width: 100%;
  box-sizing: border-box;
  ${props =>
    props.bottomMargin
      ? css`
          margin-bottom: 20px;
        `
      : ""};
  flex-direction: ${props => (props.question ? "row" : "row-reverse")};
`

const Bubble = styled.div`
  display: block;
  position: relative;
  align-items: center;
  max-width: 400px;
  justify-content: center;
  padding: 0;
  border-radius: 8px;
  box-sizing: border-box;
  background: white;
  opacity: ${props => (props.isLast ? "1" : "0.5")};
  ${props =>
    props.question
      ? css`
          margin-right: 0.889rem;
          border-bottom-left-radius: 0;
        `
      : css`
          margin-left: 0.889rem;
          border-bottom-right-radius: 0;
        `};

  ${props =>
    props.margin
      ? css`
          margin: ${props.margin};
        `
      : ""}
`

const BubbleText = styled(Text)`
  color: ${colors.neutralDarkest};
  font-weight: ${fontWeight.light};
`

const Icon = styled.img`
  display: flex;
  width: 100%;
  height: 100%;
`

export const getChatIcon = ({ brandConfigs, item = {} }) => {
  if (
    brandConfigs &&
    brandConfigs.visit_chat &&
    brandConfigs.visit_chat.images.hasOwnProperty("chat_icon") &&
    !window.no_brand_logo_ab_test
  ) {
    const chatIconSrc = brandConfigs.visit_chat.images.chat_icon.image_src
    return (
      <ChatIconWrapper id={`chat-icon-${item.index}`} className="chat-icon">
        <Icon src={`${SITE_URL}${STATIC_URL}${chatIconSrc}`} />
      </ChatIconWrapper>
    )
  } else {
    return <BuoyChatIcon id={`chat-icon-${item.index}`} />
  }
}

const ChatBubble = props => {
  if (props.item.noIcon) {
    return null
  }
  return (
    <Container
      {...props}
      hide={props.item.type === "temporaryMessage" && props.item.finished}
      className={props.question ? "bubble-question" : "bubble-response"}
      id={`chat-bubble-${props.item.index}`}
    >
      <Bubble {...props}>
        {props.question && props.brand && getChatIcon(props)}
        <LinkedText onClick={props.imageLinkClick} {...props} />
        {props.item.link && (
          <Link size="bodyMain" onClick={props.linkClick}>
            {props.item.linkText}
          </Link>
        )}
      </Bubble>
    </Container>
  )
}

const LinkedText = ({ text, onClick, ...props }) => {
  if (!text) {
    return <span />
  }
  let sections = text.split(/\[|]/)
  return sections.map((x, i) => {
    return i % 2 ? (
      <Link size="bodyMain" key={i} onClick={() => onClick(x)}>
        {x}
      </Link>
    ) : (
      <BubbleText {...props} key={i}>
        <RawHTML>{x}</RawHTML>
      </BubbleText>
    )
  })
}

export { ChatBubble as default, Icon, Container, Bubble, Link }



// WEBPACK FOOTER //
// ./assets/interview/components/ChatBubble.js